import { useTranslation } from "react-i18next"

import Icon from "@/components/Icon"
import { Button } from "@/components/ui/button"

type Props = {
  isLoading?: boolean
  onRefreshPage: () => void
}
/** Basic error page in the Call Panel, asking the user to refresh page */
export function StatelessResetView({ isLoading, onRefreshPage }: Props) {
  const { t } = useTranslation()

  return (
    <div
      className="flex size-full flex-col items-center gap-y-6 px-8 pt-36 pb-8"
      data-unmask
    >
      <Icon name="alert" size="md" className="text-danger-200" />
      <div className="flex flex-col gap-y-2 text-neutral-700">
        <h1 className="font-h1-bold">{t("callPanel.resetState.title")}</h1>
        <p className="font-body-large-regular">
          {t("callPanel.resetState.subtitle")}
        </p>
      </div>
      <Button
        type="button"
        onClick={onRefreshPage}
        isLoading={isLoading}
        isDisabled={isLoading}
        loadingMessage={t("global.loadingResetView")}
      >
        {t("global.button.refreshPage")}
      </Button>
    </div>
  )
}
